import React, { useState } from 'react';
import { forNamespace } from 'app/common/lib/util/i18n';
import styles from './TeamfulCollaborationPrompt.less';
import { TeamfulCollaborationAddBoards } from './TeamfulCollaborationAddBoards';
import { TeamfulCollaborationAddPeople } from './TeamfulCollaborationAddPeople';
import { TeamfulCollaborationSuccessMessage } from './TeamfulCollaborationSuccessMessage';
import Icon, { IconColor, IconName } from 'app/common/components/controls/icon';
import { Noun, Verb, trackUe } from '@trello/analytics';

const format = forNamespace('teamful collaboration prompt');

interface TeamfulCollaborationPromptProps {
  onClose: () => void;
  orgId: string;
}
export const TeamfulCollaborationPrompt: React.FunctionComponent<TeamfulCollaborationPromptProps> = ({
  onClose,
  orgId,
}) => {
  const [shouldShowSuccessMessage, setShowSuccessMessage] = useState(false);
  const [shouldShowAddPeople, setShouldShowAddPeople] = useState(false);

  const getPromptContent = () => {
    if (shouldShowSuccessMessage) {
      return (
        <TeamfulCollaborationSuccessMessage onClose={onClose} orgId={orgId} />
      );
    }
    if (shouldShowAddPeople) {
      return (
        <TeamfulCollaborationAddPeople
          onContinue={() => setShowSuccessMessage(true)}
          orgId={orgId}
        />
      );
    }
    return (
      <TeamfulCollaborationAddBoards
        onContinue={() => setShouldShowAddPeople(true)}
        skipToSuccess={() => setShowSuccessMessage(true)}
        orgId={orgId}
      />
    );
  };

  const onClosePromptTrackingEvent = () => {
    onClose();
    trackUe({
      category: Noun.TEAM_PAGE,
      verb: Verb.CLOSES,
      directObj: Noun.TEAMLESS_COLLABORATION_PROMPT,
      method: 'by clicking the close button',
    });
  };

  return (
    <div className={styles.teamfulCollaborationPrompt}>
      <div className={styles.popover}>
        <div className={styles.popoverHeader}>
          {format('popover title')}
          <div
            className={styles.popoverCloseButton}
            onClick={onClosePromptTrackingEvent}
            role="button"
          >
            <Icon color={IconColor.Gray} name={IconName.Close} small />
          </div>
        </div>
        <div className={styles.popoverContent}>{getPromptContent()}</div>
      </div>
      <div className={styles.arrowWrapper}>
        <div className={styles.arrow} />
      </div>
      <div className={styles.iconWrapper}>
        <img
          src={require('resources/images/taco.png')}
          alt=""
          role="presentation"
        />
      </div>
    </div>
  );
};
